<template>
    <div class="preview">
        <button v-if="showActions" class="action d-flex justify-content-center align-items-center" @click="remove">
            <icon name="times" />
        </button>
        <div @click="!showActions && go()" v-if="file.extension === 'pdf' || file.type === 'pdf'" :class="`${!showActions && 'click'}`">
            <icon name="file-pdf" scale="9" />
        </div>
        <div @click="!showActions && go()" class="img" :class="`${!showActions && 'click'}`" :style="`background-image: url('${preview}');`" v-else></div>
        <span>{{ file.url.name }}</span>
    </div>
</template>
<script>
import 'vue-awesome/icons/file-pdf'
import 'vue-awesome/icons/times'

export default {
    props: {
        file: Object,
        onRemove: Function,
        showActions: Boolean,
    },
    data() {
        return {
            preview: null,
        }
    },
    watch: {
        file: function (newVal, olVal) {
            if (typeof this.file.url === 'string') this.preview = this.file.url
            else this.getDataURL()
            this.file.extension = newVal.extension
        },
    },
    methods: {
        go() {
            if (typeof this.file.url == 'string') window.open(this.file.url)
            else window.open(this.preview)
        },
        remove() {
            this.onRemove(this.file)
        },
        getDataURL() {
            let reader = new FileReader()
            reader.onloadend = () => {
                this.preview = reader.result
            }

            reader.readAsDataURL(this.file.url)
        },
    },
    mounted() {
        if (typeof this.file.url === 'string') this.preview = this.file.url
        else this.getDataURL()
    },
    updated() {
        if (typeof this.file.url === 'string') this.preview = this.file.url
        else this.getDataURL()
    },
}
</script>
<style lang="scss" scoped>
.click {
    cursor: pointer;
    transition: transform 0.3s;
    transform: scale(1);
    &:hover {
        transition: transform 0.3s;
        transform: scale(1.05);
    }
}

.preview {
    display: flex;
    position: relative;
    flex-direction: column;
    margin-right: 15px;
    max-width: 300px;

    .action {
        height: 24px;
        width: 24px;
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        border: none;
        border-bottom-right-radius: 50%;
        color: var(--light) !important;
        left: 0;
        top: 0;
    }

    div > svg {
        color: var(--gray);
    }

    .img {
        height: 140px;
        width: auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }

    span {
        color: var(--light);
        font-size: 14px;
        font-weight: 300;
        width: 120px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
